module.exports = __webpack_public_path__ + "static/media/hanroplus.0a0ac06b.jpg";